import useSupplier from "hooks/useSupplier";

const useCurrentSupplierCompanyId = (): string | undefined => {
  const [supplier] = useSupplier();

  return supplier?.supplierCompanyToSuppliers?.[0]?.supplierCompanyId;
};

export default useCurrentSupplierCompanyId;
